import React, { useState, useEffect } from "react";
import {Link, useLocation,  useNavigate,  useSearchParams,} from "react-router-dom";
import axios from "axios";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Preloader from "../Preloder/Preloader";
import "./Studentexam.css";

const StudentExam = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: localStorage.getItem("username"),
    fathername: "",
    UserId: localStorage.getItem("UserId"),
    school: "",
    medium: "",
    selectedExamtype: "",
    standard: "",
    bonafideImage: null,
    photoImage: null,
  });
  const [examtypes, setExamtypes] = useState([]); // list from API
  // const [selectedExam, setSelectedExam] = useState(""); // dropdown selected value
  const [paymentState, setPaymentState] = useState("");
  const [merchantOrderId, setMerchantOrderId] = useState("");
  const [message, setMessage] = useState("");
  const [paymentUrl, setPaymentUrl] = useState("");
  // const [examtype, setExamtype] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const OrderId = searchParams.get("orderId");
  
  const MediumtoStandard = {
    Tamil: [
      "VI",
      "VII",
      "VIII",
      "IX",
      "X",
      "XI MathsBiology",
      "XI Computer Science",
      "XI Science",
      "XI Commerce",
      "XI Electrical",
      "XI Civil",
      "XI History",
      "XII MathsBiology",
      "XII Computer Science",
      "XII Science",
      "XII Commerce",
      "XII Electrical",
      "XII Civil",
      "XII History",
      "ITI ",
      "Diploma",
      "PG (Postgraduate)",
      "UG  (Undergraduate) ",
    ],
    English: [
      "VI",
      "VII",
      "VIII",
      "IX",
      "X",
      "XI MathsBiology",
      "XI Computer Science",
      "XI Science",
      "XI Commerce",
      "XI Electrical",
      "XI Civil",
      "XI History",
      "XII MathsBiology",
      "XII Computer Science",
      "XII Science",
      "XII Commerce",
      "XII Electrical",
      "XII Civil",
      "XII History",
      "ITI ",
      "Diploma",
      "PG (Postgraduate)",
      "UG  (Undergraduate) ",
    ],
  };

  // Initialize form data from location state or session storage
  localStorage.setItem("formData", JSON.stringify(formData));

  useEffect(() => {
    const { paymentState: passedPaymentState } = location.state || {};

    if (passedPaymentState) {
      setPaymentState(passedPaymentState);
    }
  }, [location.state]);

  // Verify payment if orderId exists in URL
  useEffect(() => {
    const verifyPaymentIfNeeded = async () => {
      if (OrderId) {
        const token = await getAuthToken();
        if (token) await verifyPayment(OrderId, token);
      }
    };
    verifyPaymentIfNeeded();
  }, [OrderId]);

  const getAuthToken = async () => {
    try {
      const response = await axios.post(
        `https://ramjitrust.org:4000/payment/get-auth-token`
      );
      return response.data.access_token;
    } catch (error) {
      console.error("Error fetching auth token:", error);
      setMessage("Failed to initialize payment system");
      return null;
    }
  };

  const generateOrderId = () => {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 10000);
    return `ORD_${timestamp}_${random}`.slice(0, 63);
  };

  const initiatePayment = async () => {
    // First validate form
    const requiredFields = [
      "name",
      "fathername",
      "school",
      "medium",
      "standard",
      "bonafideImage",
      "photoImage",
    ];
    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      setMessage(
        `Please fill all required fields: ${missingFields.join(", ")}`
      );
      return;
    }

    setLoading(true);
    try {
      const token = await getAuthToken();
      if (!token) return;

      const generatedOrderId = generateOrderId();
      setMerchantOrderId(generatedOrderId);
      // ✅ Build FormData
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value) formDataToSend.append(key, value);
      });
      formDataToSend.append("orderId", generatedOrderId); // Tag it

      // ✅ Save the full form with files before redirect
      await axios.post(
        `https://ramjitrust.org:4000/form/save-temp`,
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const response = await axios.post(
        `https://ramjitrust.org:4000/payment/initiate-payment`,
        {
          amount: 150,
          merchantOrderId: generatedOrderId,
          token,
        }
      );

      setPaymentUrl(response.data.redirectUrl);
      window.location.href = response.data.redirectUrl;
    } catch (error) {
      console.error("Payment initiation failed:", error);
      setMessage("Failed to initiate payment. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const verifyPayment = async (orderId, token) => {
    try {
      const res = await axios.post(
        `https://ramjitrust.org:4000/payment/verify-payment`,
        {
          orderId,
          token,
        }
      );

      const state = res.data?.state;
      setPaymentState(state);

      if (state === "COMPLETED") {
        // If payment is complete, submit the form
        await submitForm();
        alert("✅ Payment Successful");
      } else if (state === "FAILED") {
        alert("❌ Payment Failed");
      } else if (state === "PENDING") {
        alert("⏳ Payment is still pending");
      }
    } catch (error) {
      console.error("Error verifying payment:", error);
      alert("❌ Could not verify payment.");
    }
  };

  const submitForm = async () => {
    setLoading(true);
    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formDataToSend.append(key, value);
        }
      });

      // Debug: Log form fields before sending
      console.log("🔍 Submitting form with the following data:");
      for (let pair of formDataToSend.entries()) {
        // console.log(`${pair[0]}:`, pair[1]);
      }

      const apiUrl = `${process.env.REACT_APP_API}/auth/register`;
      // console.log("🌐 API Endpoint:", apiUrl);

      const response = await axios.post(apiUrl, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // console.log("✅ Registration response:", response);

      if (response.status === 200 || response.status === 201) {
        setMessage(response.data.message || "Registration successful!");
        console.log("🎉 Registration success!");

        // Reset form
        setFormData({
          name: "",
          fathername: "",
          UserId: "",
          school: "",
          medium: "",
          selectedExamtype: "",
          standard: "",
          bonafideImage: null,
          photoImage: null,
        });
      }
    } catch (error) {
      console.error("❌ Registration error:", error);
      console.error("📨 Error response:", error.response);
      setMessage(
        error.response?.data?.message ||
          "Registration failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleMediumChange = (e) => {
    const medium = e.target.value;
    setFormData((prev) => ({
      ...prev,
      medium,
      standard: "", // Reset standard when medium changes
    }));
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "PENDING":
        return "orange";
      case "FAILED":
        return "red";
      case "COMPLETED":
        return "green";
      default:
        return "gray";
    }
  };

  const standards = MediumtoStandard[formData.medium] || [];

  useEffect(() => {
    getexamtype();
  }, []);

  // fetch exam types
  const getexamtype = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/questions/getexamtype`);
      const today = new Date();

      // filter only active exams
      const filtered = res.data.data.filter(
        (exam) => new Date(exam.to_date) >= today
      );

      // setExamtypes(filtered);
      setExamtypes(res.data.data);

      // console.log(filtered)
    } catch (error) {
      console.log(error);
    }
  };

  // handle dropdown change
  // const handleExamChange = (e) => {
  //   setSelectedExam(e.target.value);
  // };
const registerExam = async () => {
      setLoading(true);
  try {
    const requiredFields = [
      "name",
      "fathername",
      "UserId",
      "school",
      "medium",
      "selectedExamtype",
      "standard",
      "photoImage",
      "bonafideImage"
    ];

    for (let field of requiredFields) {
      if (!formData[field]) {
        alert(`Please fill the "${field}" field.`);
        return;
      }
    }

    const formDataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formDataToSend.append(key, value);
      }
    });

    const response = await axios.post(
      `${process.env.REACT_APP_API}/auth/exam_regester`,
      formDataToSend,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    // ✅ Always show the backend message
    alert(response.data.message || "No response message");

    // ✅ Reset only if success
    if (response.data.message === "Registration successful") {
      setFormData({
        name: "",
        fathername: "",
        UserId: "",
        school: "",
        medium: "",
        selectedExamtype: "",
        standard: "",
        bonafideImage: null,
        photoImage: null,
      });
    }
  } catch (error) {
    console.error("Error during exam registration:", error);
  if (error.response && error.response.data && error.response.data.message) {
    alert(error.response.data.message);
  } else {
    alert("Something went wrong.");
  }
  }
   finally {
      setLoading(false);
    }
};




 const handleCheck = async () => {
  const userid = localStorage.getItem("UserId");

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API}/questions/checkstudent`,
      { userid } // Send userid inside an object
    );

    const message = response.data.message;

    if (message === "Payment required: Please pay monthly plan") {
      alert(message);
      // initialpayment(); // Call the function for payment
    } else if (message === "Payment up-to-date") {
      // alert(message)
      registerExam();
    } else {
      console.warn("Unexpected response:", message);
    }
  } catch (error) {
    console.error("Error checking student payment status:", error);
    alert("An error occurred while checking payment status.");
  }
};


  return (
    <div>
      <Preloader/>
      <div style={{ marginBottom: "50px" }}>
        <Link to="/" className="logo_image">
          <img
            src="assets/headimg.jpg"
            alt="Cleenhearts HTML"
            style={{ width: "100%" }}
          />
        </Link>
      </div>

      <section className="student-exam-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="exam-form-card">
                <h2 className="text-center mb-4">Student Exam Registration</h2>

                {message && (
                  <div
                    className={`alert ${
                      message.includes("success")
                        ? "alert-success"
                        : "alert-danger"
                    }`}
                  >
                    {message}
                  </div>
                )}

                <form>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Full Name"
                          value={formData.name}
                          name="name"
                          onChange={handleChange}
                          required
                          readOnly
                        />
                        <label htmlFor="name">Student Name</label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="fathername"
                          placeholder="Father's Name"
                          value={formData.fathername}
                          name="fathername"
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="fathername">Father's Name</label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating">
                        <select
                          id="medium"
                          name="medium"
                          className="form-control"
                          value={formData.medium}
                          onChange={handleMediumChange}
                          required
                        >
                          <option value="">Select Medium</option>
                          {Object.keys(MediumtoStandard).map((medium) => (
                            <option key={medium} value={medium}>
                              {medium}
                            </option>
                          ))}
                        </select>
                        <label htmlFor="medium">Medium</label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating">
                        <select
                          id="standard"
                          name="standard"
                          className="form-control"
                          value={formData.standard}
                          onChange={handleChange}
                          disabled={!formData.medium}
                          required
                        >
                          <option value="">Select Standard</option>
                          {standards.map((standard, index) => (
                            <option key={index} value={standard}>
                              {standard}
                            </option>
                          ))}
                        </select>
                        <label htmlFor="standard">Standard</label>
                      </div>
                    </div>

                    {/* //////////////////////////////////////////////////////////// */}
            <div className="col-md-6">
  <div className="form-floating">
    <select
      id="standard"
      name="selectedExamtype"
      className="form-control"
      value={formData.selectedExamtype}
      onChange={handleChange}
      disabled={!formData.standard}
      required
    >
   {
  examtypes.filter(exam => 
    exam.section_names
      ?.split(',')
      .map(name => name.trim())
      .includes(formData.standard)
  ).length === 0 ? (
    <option value="">No Exam Scheduled</option>
  ) : (
    <>
      <option value="">Select Exam Type</option>
      {examtypes
        .filter(exam =>
          exam.section_names
            ?.split(',')
            .map(name => name.trim())
            .includes(formData.standard)
        )
        .map((exam) => (
          <option key={exam.id} value={exam.id}>
            {exam.title}
          </option>
        ))}
    </>
  )
}

    </select>
    <label htmlFor="standard">Exam Type</label>
  </div>
</div>


                    {/* ///////////////////////////////////////////////////////// */}

                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="school"
                          placeholder="School / College"
                          value={formData.school}
                          name="school"
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="school">School/College</label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="file"
                          className="form-control"
                          id="bonafideImage"
                          name="bonafideImage"
                          accept="image/*"
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="bonafideImage">
                          Bonafide / ID Photo
                        </label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="file"
                          className="form-control"
                          id="photoImage"
                          name="photoImage"
                          accept="image/*"
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="photoImage">Upload Photo</label>
                      </div>
                    </div>

                    <div className="col-12">
                      {paymentState !== "COMPLETED" ? (
                       <button
  type="button"
  className="button"
  onClick={() => {
    if (!loading) handleCheck();
  }}
>
  {loading ? (
    <span className="loader-spinner">Processing...</span>
  ) : (
    <>
      <span>A</span>
      <span>P</span>
      <span>P</span>
      <span>L</span>
      <span>A</span>
      <span>Y</span>
    </>
  )}
</button>

                      ) : (
                        <div className="payment-status">
                          Payment Status:
                          <span
                            style={{
                              color: getStatusColor(paymentState),
                              fontWeight: "bold",
                            }}
                          >
                            {paymentState}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default StudentExam;
